import { ReactElement, ReactNode } from 'react';

import './details-group.scss';

type DetailsGroupProps = {
  label?: string;
  children: ReactNode;
};

export function DetailsGroup({ label, children }: DetailsGroupProps): ReactElement {
  return (
    <div className="p-top-l">
      {label && (
        <div className="details-group__label color-gray-800 text-italic m-bottom-l">
          {label}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
}
